import styled from 'styled-components'

const CheckBoxInput = styled.input`
  display: none;

  + label {
    display: block;
    padding-left: 28px;
    transition: all 0.2s;
  }

  + label::before,
  + label::after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: all 0.2s;
  }

  + label::before {
    background-color: #fff;
    border: 1px solid #999;
    height: 20px;
    left: 0;
    width: 20px;
  }

  + label::after {
    border-bottom: 4px solid #fff;
    border-left: 4px solid #fff;
    height: 15px;
    left: -2px;
    margin-top: -10px;
    opacity: 0;
    transform: rotate(-45deg) scale(0.5);
    width: 25px;
  }

  &:checked + label::before {
    background-color: #ec4444;
    border: 1px solid #fff;
  }

  &:checked + label::after {
    opacity: 1;
  }
`

export default CheckBoxInput
